'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.ScheduleChange.ReviewRulesErrorModal', dependencies).directive('rmReviewRulesErrorModal', require('./directives/ReviewRulesErrorModalDirective'));